<template>
    <span></span>
</template>

<script>
    export default {
        name: 'NotFound404'
    }
</script>
